import infoShow from "./infoShow";
import infoPayload from "../helpers/payloadHandlers/infoPayload";

const showMessage= (type, message, description='') => async (dispatch) => {
    dispatch(infoShow(infoPayload(type,message,description)))
};
export default showMessage;